import { RpcResult } from 'centrifuge';
import { WS_MESSAGE_TYPE } from 'api/websockets';
import type { ISubscription } from '../Subscription/types';

export interface IRPCHandler<T = any> {
  on(messageType: WS_MESSAGE_TYPE, callback: (data: T) => void): IRPCHandler<T>;
  trigger(): Promise<RpcResult | undefined>;
  unsubscribe(): void;
}

class RPCHandler<T = any> implements IRPCHandler<T> {
  private _isTriggered = false;

  constructor(
    private _subscription: ISubscription,
    private _sendFn: () => Promise<RpcResult>,
  ) {}

  on(messageType: WS_MESSAGE_TYPE, callback: (data: T) => void): IRPCHandler<T> {
    this._subscription.subscribe(callback, messageType);

    return this;
  }

  trigger(): Promise<RpcResult | undefined> {
    if (!this._isTriggered) {
      this._isTriggered = true;

      return this._sendFn();
    }

    return Promise.resolve(undefined);
  }

  unsubscribe(): void {
    this._subscription.unsubscribe();
  }
}

export default RPCHandler;
